import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { deletePcmpProject, pcmpProjectQueryKeys } from '../api/pcmpProjects.api';

export function useDeletePcmpProject(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deletePcmpProject(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: pcmpProjectQueryKeys.all() });
      toast.success('Project deleted');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to delete the project');
    },
  });
}
